import './PromoLinks.sass';

import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { List, ListItem } from '$uikit';
import { IcCopy20 } from '$assets';
import { useTranslator } from '$hooks';
import { goTo, showModal } from '$navigation/helper';
import { STATISTICS_PRO_LINKS } from '$shared/constants/pages';
import { promoLinksActions, promoLinksSelector } from '$store/promoLinks';
import { PromoLinksProps } from '$core/Invite/PromoLinks/PromoLinks.interface';

export const PromoLinks: FC<PromoLinksProps> = ({
  referralLink,
  telegramLink,
  onCopyReferral,
  onCopyTelegram,
}) => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const { links } = useSelector(promoLinksSelector);

  useEffect(() => {
    dispatch(promoLinksActions.loadLinks());
  }, []);

  return (
    <div className="PromoLinks">
      <List
        title={t('promo_links_group_referral', { defaultValue: 'Referral links' })}
        description={t('promo_links_group_referral_desc', {
          defaultValue:
            'Your permanent links. Anyone who joins through them becomes your referral.',
        })}
      >
        <ListItem
          onClick={onCopyReferral}
          description={referralLink}
          descriptionSingleLine
          indicator={<IcCopy20 />}
        >
          {t('invite_link_title')}
        </ListItem>
        {!!telegramLink && (
          <ListItem
            onClick={onCopyTelegram}
            description={telegramLink}
            descriptionSingleLine
            indicator={<IcCopy20 />}
          >
            {t('invite_link_title_telegram')}
          </ListItem>
        )}
      </List>

      <List
        description={t('promo_links_group_promo_desc', {
          defaultValue:
            'A separate link for every place you advertise — so you can see where the traffic came from.',
        })}
      >
        <ListItem
          chevron
          onClick={() =>
            links.length
              ? showModal('promo_links')
              : showModal('create_promo_link', false, { editLinkId: 0 })
          }
          indicator={links.length.toString()}
        >
          {t('promo_links_all_title', { defaultValue: 'Custom links' })}
        </ListItem>
        <ListItem chevron onClick={() => goTo(STATISTICS_PRO_LINKS)}>
          {t('promo_links_stats_title', { defaultValue: 'Statistics' })}
        </ListItem>
      </List>
    </div>
  );
};
